import {
  OrderDirection,
  userDetails,
} from "../../../../../utils/commonQueryTypes";
import { EmpMaster } from "../../users/queries/types";

export interface AddMomVars {
  customerID: number;
  user_details: userDetails;
  meetingDate: string;
}

export interface AddMomResult {
  AddMom: boolean;
}

export enum AtsMomMasterOrderField {
  MEETING_DATE = "MEETING_DATE",
}

export interface AtsMomMasterOrder {
  direction: OrderDirection;
  field: AtsMomMasterOrderField;
}

export interface AtsMomMaster {
  id: number;
  meetingNo: string;
  meetingDate: string;
}

// The edge containing a node and its cursor
export interface MomEdge {
  node: AtsMomMaster;
  cursor: string;
}

// PageInfo for pagination details
export interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

// The actual response from the GetMoms query
export interface GetMomsData {
  GetMoms: {
    edges: MomEdge[];
    pageInfo: PageInfo;
    totalCount: number;
  };
}

// The variables required for the GetMoms query
export interface GetMomsVars {
  after: string | null;
  first: number;
  startDate: string | undefined;
  endDate: string | undefined;
  customerID: number;
  orderBy: AtsMomMasterOrder;
}

export interface UpdateMomMutationVariables {
  momID: number;
  user_details: userDetails;
  meetingDate: string;
}

export interface UpdateMomMutation {
  UpdateMom: boolean;
}

export interface DeleteMomMutationVariables {
  momID: number;
  user_details: userDetails;
}

export interface DeleteMomMutation {
  DeleteMom: boolean;
}

export interface GetMomDetailsVars {
  customerID: number;
  momID: number;
  projectID: number;
  latest: boolean;
}

export interface AtsMomDetails {
  id: number;
  pmuComments: string;
  vendorResponse: string;
  pmuDocuments: string;
  vendorDocuments: string;
  pmuResponse: string;
  pmuResponseDocuments: string;
  customerID: number;
  momID: number;
  projectID: number;
  momMasterDetails: AtsMomMaster;
  vendorNotes: string;
  vendorNotesDocuments: string;
  actionTaken: string
}

export interface GetMomDetailsResult {
  GetMomDetails: AtsMomDetails[];
}

export interface PmuCommentsInput {
  pmuComments: string;
  pmuDocuments: string;
  actionTaken?: string
}

export interface AddPmuCommentsVars {
  customerID: number;
  momID: number;
  projectID: number;
  user_details: userDetails;
  input: PmuCommentsInput[];
}

export interface AddPmuCommentsResult {
  AddPmuComments: AtsMomDetails[];
}

export interface VendorResponseInput {
  vendorResponse: string;
  vendorDocuments: string;
  momDetailsID: number;
}
export interface UpdateVendorResponseVars {
  customerID: number;
  momID: number;
  projectID: number;
  user_details: userDetails;
  input: VendorResponseInput[];
}
export interface UpdateVendorResponseResult {
  UpdateVendorResponse: boolean;
}

export interface UpdatePmuCommentsVars {
  customerID: number;
  momDetailsID: number;
  user_details: userDetails;
  input: PmuCommentsInput;
}

export interface UpdatePmuCommentsResult {
  UpdatePmuComments: boolean;
}

export interface DeletePmuCommentsVars {
  customerID: number;
  momDetailsID: number;
  user_details: userDetails;
}

export interface DeletePmuCommentsResult {
  DeletePmuComments: boolean;
}

export interface AttendanceData {
  invitees: string;
  momID: number;
  projectID: number;
  empIds: number[];
}

export interface AddMomAttVars {
  customerID: number;
  user_details: userDetails;
  input: AttendanceData;
}

export interface AddMomAttResult {
  AddMomAtt: boolean;
}

export interface GetMomAttCountVars {
  customerID: number;
  momID: number;
  projectID: number;
  latest: boolean;
}

interface AttCount {
  empCount: number;
  inviteesCount: number;
}

export interface GetMomAttCountResult {
  GetMomAttCount: AttCount;
}

export interface GetMomAttVars {
  customerID: number;
  momID: number;
  projectID: number;
  latest: boolean;
}

export interface GetMomAttResult {
  GetMomAtt: {
    empDetails: EmpMaster;
  }[];
}

export interface VendorNotesInput {
  vendorNotes: string;
  vendorNotesDocuments: string;
}

export interface AddVendorNotesVars {
  customerID: number;
  momID: number;
  projectID: number;
  user_details: userDetails;
  input: VendorNotesInput[];
}

export interface AddVendorNotesResult {
  AddVendorNotes: {
    id: number;
  }[];
}
export interface GetVendorNotesVars {
  customerID: number;
  momID: number;
  projectID: number;
  latest: boolean;
}

export interface VendorNotes {
  id: number;
  vendorNotes: string;
  vendorNotesDocuments: string;
}

export interface GetVendorNotesResult {
  GetVendorNotes: VendorNotes[];
}

export interface UpdateVendorNotesVars {
  customerID: number;
  momDetailsID: number;
  user_details: userDetails;
  input: VendorNotesInput;
}

export interface UpdateVendorNotesResult {
  UpdateVendorNotes: boolean;
}

export interface DeleteVendorNotesVars {
  customerID: number;
  momDetailsID: number;
  user_details: userDetails;
}

export interface DeleteVendorNotesResult {
  DeleteVendorNotes: boolean;
}

export interface GetMomInviteesVars {
  customerID: number;
  momID: number;
  projectID: number;
  latest: boolean;
}

export interface GetMomInviteesResult {
  GetMomInvitees: string[];
}

export interface GetMomsForProjectVars {
  customerID: number;
  projectID: number;
  empID: number;
}
interface ProjectWiseMomDetails {
  momID: number;
  meetingDate: string;
  pmuCount: number;
  vendorRespCount: number;
  attCount: number;
}
export interface GetMomsForProjectResult {
  GetMomsForProject: ProjectWiseMomDetails[];
}

export interface GetMomNodeVars {
  customerID: number;
  momID: number;
  latest: boolean;
}

export interface GetMomNodeResult {
  GetMomNode: AtsMomMaster;
}

export interface PmuResponseInput {
  pmuResponse: string;
  pmuResponseDocuments: string;
}

export interface UpdatePmuResponseVars {
  customerID: number;
  momDetailsID: number;
  user_details: userDetails;
  input: PmuResponseInput;
}

export interface UpdatePmuResponseResult {
  UpdatePmuResponse: boolean;
}

export interface UpdateViewedStatusResult {
  UpdateViewedStatus: boolean;
}

export interface UpdateViewedStatusVar {
  token?: string;
  user_details: userDetails;
  customerID: number;
  momID: number;
  projectID: number;
  viewed: Boolean;
}
